import React, { CSSProperties, useContext } from 'react';
import Image from '../Image';
import { translate } from 'infras/i18n';
import styled from '@emotion/styled';
import { ThemeContext } from '@emotion/react';
import { mediaMax } from 'presentations/views/styles';
import { Appearance } from 'presentations/views/styles/color';

interface Props {
  className?: string;
  width?: number;
  height?: number;
  style?: CSSProperties;
  isDarkable?: boolean;
  variant?: 'www' | 'gray' | 'white';
}

export default function Component(props: Props) {
  const context: any = useContext(ThemeContext);
  let src =
    context?.appearance === Appearance.Gray
      ? 'gray.svg'
      : props.isDarkable && context?.appearance === Appearance.Dark
      ? 'www_white.svg'
      : 'www.svg';
  if (props.variant === 'gray') {
    src = 'logo_jicoo-gray.svg';
  }
  if (props.variant === 'white') {
    src = 'www_white.svg';
  }
  return (
    <ServiceLogo
      className={props.className}
      src={`logo/${src}`}
      alt={translate('siteName')}
      style={props.style}
      dpr={2}
      width={props.width}
      height={props.height}
    />
  );
}

export const SymbolLogo = (props: Props) => {
  return (
    <ServiceLogo
      className={props.className}
      src={'logo/symbol.svg'}
      alt={translate('siteName')}
      style={props.style}
      width={props.width}
      height={props.height}
    />
  );
};

const ServiceLogo = styled(Image)`
  ${mediaMax.tablet} {
    height: auto;
  }
`;
